module.exports = __webpack_public_path__ + "img/arrival_5.682295a9.jpg";